import { Component, OnInit, Input,  Inject, PLATFORM_ID, AfterViewInit } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { isPlatformServer } from '@angular/common';
import Swiper from 'swiper';

@Component({
  selector: 'app-content-array-module',
  templateUrl: './content-array-module.component.html',
})
export class ContentArrayModuleComponent implements OnInit, AfterViewInit {
  @Input() rendering: ComponentRendering;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  isMobile: boolean;
  swiper: Swiper;
  _isPlatformServer: boolean = false;
  
  loopLength: number;
  selectedGroup: any;
  groupList: any[] = [];
  showMoreBtn: boolean = true;

  constructor(jssStylingService: JssStylingService,
    @Inject(PLATFORM_ID) public readonly platformId: string,
    ) { 
    this.jssStylingService = jssStylingService;
    platformId 
  }


  ngOnInit() {
    this._isPlatformServer = isPlatformServer(this.platformId);
    // remove this after implementation is done
    console.log('ContentArrayModule component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);

    this.loopLength = (this.rendering.fields?.PageSize as any).value ? (this.rendering.fields?.PageSize as any).value : 6;
    this.selectedGroup = (this.rendering?.fields?.GroupItems as any)[0];
    this.createGroupList(this.selectedGroup);

  }

  ngAfterViewInit() {
    if(!this._isPlatformServer) {
      this.swiper = new Swiper(".eq-swiper-filter", {
        slidesPerView: "auto",
        freeMode: true,
        centeredSlides: false,
        spaceBetween: 32,
        grabCursor: true,
        breakpoints: {
          1024: {
            enabled: false,
          },
        },
      });
    }
  }

  createGroupList(item: any) {
    this.selectedGroup = item;
    this.groupList.length = 0;
    this.showMoreBtn = true;
    for (let i = 0; i < this.loopLength; i++) {
      if (this.selectedGroup?.fields?.Cards[i]) {
        this.groupList.push(this.createGroupCard(this.selectedGroup?.fields?.Cards[i]));
      }
    }
    this.showMoreBtn = !(this.groupList.length == this.selectedGroup?.fields?.Cards.length);

    if(this.swiper){
      this.swiper.slideTo(this.swiper.slides.findIndex((x: any) => x.classList.contains("pb-filter--active")));
    }
  }

  createGroupCard(item: any){
    const card = {
      Title: item.fields?.Title?.value,
      Description: item.fields?.Description?.value,
      Link: {
        href: item?.fields?.Link?.value?.href,
        text: item?.fields?.Link?.value?.text,
        linktype: item?.fields?.Link?.value?.linktype,
        url: item?.fields?.Link?.value?.url,
        anchor: item?.fields?.Link?.value?.anchor,
        target: item?.fields?.Link?.value?.target
      },
      Image: {
        src: item.fields?.ArticleImage?.value.src,
        alt: item.fields?.ArticleImage?.value.alt
      },
      Type: item.fields?.Type.value.toLowerCase()
    }
    return card;
  }

  showMore() {
    let loopLength2 =
      (this.rendering?.fields?.PageSize as any)?.value > 0
      ? (this.rendering?.fields?.PageSize as any)?.value + this.groupList.length
      : 6 + this.groupList.length;
    for (let i = this.groupList.length; i < loopLength2; i++) {
      if ((this.selectedGroup.fields.Cards as any)[i]) {
        this.groupList.push(this.createGroupCard((this.selectedGroup.fields.Cards as any)[i]));
      } else {
        break;
      }
    }
    this.showMoreBtn = (this.selectedGroup.fields.Cards as any)?.length > this.groupList.length;
  }
}